import { Button, Col, Typography } from "antd";
import { notify } from "@/shared/utils/notify";

import React from "react";
import { InputNumber, InputText } from "../../../../shared/components";
import Upload from "../../../../shared/components/ui/inputs/Upload";
import { PATH_S3_BUCKET } from "../../../../shared/utils/constants";
import { IAccompaniment } from "../../../../redux/@types";
import { useEditAccompaniment } from "../../hooks";

const { Title, Text } = Typography;

export const EditAccompanimentForm = ({
  accompaniment,
  onSuccess,
}: {
  accompaniment: IAccompaniment | undefined;
  onSuccess?: () => void;
}) => {
  const { control, handleSubmit, setValue, watch } = useEditAccompaniment({
    accompaniment,
    onSuccess,
  });
  const pathImage = watch("path_image");

  if (!accompaniment) return null;

  return (
    <form onSubmit={handleSubmit}>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Text style={{ marginBottom: "1.5px" }}>Nombre:</Text>
        <InputText placeHolder="Nombre del acompañamiento" name="name" control={control} />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Text style={{ marginBottom: "1.5px" }}>Descripción:</Text>
        <InputText placeHolder="Descripción" name="description" control={control} />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Precio:
        </Title>
        <InputNumber placeHolder="0" name="price" control={control} />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Text style={{ marginBottom: "8px" }}>Imagen:</Text>
        {pathImage ? (
          <img
            src={`${PATH_S3_BUCKET}/${pathImage}`}
            alt="Acompañamiento"
            style={{
              marginBottom: 8,
              maxWidth: 120,
              maxHeight: 120,
              objectFit: "cover",
              borderRadius: 8,
              border: "1px solid #f0f0f0",
            }}
          />
        ) : null}
        <Upload
          filePath="accompaniments"
          placeHolder="Subir imagen del acompañamiento"
          onUploadedFile={(file: any) => {
            const path = file?.fileKey || file?.key || file?.path;
            if (path) {
              setValue("path_image", path);
              notify.success("Imagen subida correctamente");
            }
          }}
        />
      </Col>
      <Button
        htmlType="submit"
        style={{
          width: "100%",
          marginTop: 10,
        }}
        type="primary"
        shape="round"
        size="large"
      >
        Guardar cambios
      </Button>
    </form>
  );
};
